// extracted by mini-css-extract-plugin
export var cartContainer = "_og-4";
export var gray = "_og-1";
export var itemContainer = "_og-2";
export var itemDetails = "_og-3";
export var strong = "_og-0";